import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CropGeneralInfo from "../components/CropGeneralInfo";

const GeneralInformationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      {/* <MasterLayout> */}
        {/* Breadcrumb */}
        <Breadcrumb title='Crop General Info' />

        {/* GalleryLayer */}
        <CropGeneralInfo />
      {/* </MasterLayout> */}
    </>
  );
};

export default GeneralInformationPage;